module.exports = __webpack_public_path__ + "img/sp_article_2.e57d75c2.jpg";